import { Event } from '../Event'
import { Identity } from '../../constants'
import { EntryPoint, ReferralMedium } from './types'

export interface ConsumerVisitedFromReferralLinkEventProperties {
  entry_point: EntryPoint
  medium: ReferralMedium
}

export class ConsumerVisitedFromReferralLinkEvent extends Event<
  ConsumerVisitedFromReferralLinkEventProperties
> {
  static displayName = 'Consumer Visited From Referral Link'

  static allowedIdentities = [Identity.Guest, Identity.Consumer]
}
